import React from "react"

const ArrowRightIcon: React.FC = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...props}>
            <path d="M6.75004 5C6.75004 5 11.25 8.31418 11.25 9.5C11.25 10.6859 6.75 14 6.75 14" stroke="#316FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default ArrowRightIcon